<!--
  Public hero landing. Hero section only (nav · hero · portal cards · sister strip),
  adapted from "LMS+ Front Page (latest local).html". Dark variant; magnetic-grid
  canvas as the hero background. Sign In / Admin → internal login route; Client /
  Caller → external subdomains (same tab); CTAs → # placeholders (TODO booking-url).
-->
<div class="landing-page">
	<!-- NAV -->
	<nav class="nav">
		<a class="nav-logo" routerLink="/" aria-label="LMS+ Leads home">
			<!-- Dark-variant LMS+ logo (mockup lines 1503–1527) -->
			<svg class="nav-logo-dark" width="196" height="55" viewBox="0 0 680 192" fill="none">
				<g transform="translate(100,96)">
					<circle cx="0" cy="0" r="78" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="12" />
					<circle cx="0" cy="0" r="32" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.1)" stroke-width="8" />
					<rect x="-9" y="-96" width="18" height="22" rx="4" fill="rgba(255,255,255,0.1)" />
					<rect x="-9" y="74" width="18" height="22" rx="4" fill="rgba(255,255,255,0.1)" />
					<rect x="74" y="-9" width="22" height="18" rx="4" fill="rgba(255,255,255,0.1)" />
					<rect x="-96" y="-9" width="22" height="18" rx="4" fill="rgba(255,255,255,0.1)" />
					<rect x="38" y="-88" width="18" height="22" rx="4" fill="rgba(255,255,255,0.1)" transform="rotate(45,38,-88)" />
					<rect x="-56" y="66" width="18" height="22" rx="4" fill="rgba(255,255,255,0.1)" transform="rotate(45,-56,66)" />
					<rect x="66" y="38" width="18" height="22" rx="4" fill="rgba(255,255,255,0.1)" transform="rotate(-45,66,38)" />
					<rect x="-88" y="-56" width="18" height="22" rx="4" fill="rgba(255,255,255,0.1)" transform="rotate(-45,-88,-56)" />
					<circle cx="0" cy="0" r="10" fill="#00d4c3" />
				</g>
				<rect x="24" y="52" width="152" height="20" rx="10" fill="white" />
				<rect x="40" y="80" width="120" height="18" rx="9" fill="#4da6f5" />
				<rect x="56" y="106" width="88" height="18" rx="9" fill="#00d4c3" />
				<rect x="72" y="132" width="56" height="16" rx="8" fill="rgba(0,212,195,.3)" />
				<circle cx="100" cy="162" r="11" fill="#22c55e" />
				<circle cx="100" cy="162" r="6" fill="white" opacity="0.9" />
				<text x="200" y="116" font-family="Barlow Condensed,sans-serif" font-weight="900" font-size="78" fill="white" letter-spacing="-2">LMS</text>
				<text x="396" y="82" font-family="Barlow,sans-serif" font-weight="800" font-size="44" fill="#00d4c3">+</text>
				<rect x="200" y="128" width="220" height="2" rx="1" fill="rgba(255,255,255,0.15)" />
				<text x="202" y="154" font-family="Barlow,sans-serif" font-weight="500" font-size="22" fill="rgba(255,255,255,0.45)" letter-spacing="9">LEADS</text>
			</svg>
		</a>
		<div class="nav-cta">
			<a class="btn-ghost" routerLink="/auth/signin/cover">Sign In</a>
			<!-- TODO(booking-url) -->
			<a class="btn-accent" [href]="requestDemoHref">Request Demo</a>
		</div>
	</nav>

	<!-- HERO -->
	<section class="hero">
		<app-login-grid-bg></app-login-grid-bg>
		<div class="hero-glow-r"></div>
		<div class="hero-glow-l"></div>
		<div class="hero-legibility" aria-hidden="true"></div>
		<div class="hero-accent-line"></div>

		<div class="hero-content">
			<div class="hero-eyebrow">
				<span class="hero-eyebrow-dot"></span>
				<span class="hero-eyebrow-text">B2B Appointment Generation</span>
			</div>

			<h1 class="hero-title">
				<span class="hl-line"><span class="w">We</span> <span class="w">generate</span> <span class="w-group tl">qualified leads</span>.</span>
				<span class="hl-line"><span class="w">You</span> <span class="w-group">close deals</span>.</span>
			</h1>

			<p class="hero-sub">
				LMS Leads handles the outbound prospecting so you don't have to — delivering
				pre-screened, appointment-ready prospects across industries on a simple
				per-lead model with no retainers.
			</p>

			<div class="hero-actions">
				<!-- TODO(booking-url) -->
				<a class="hero-cta-primary" [href]="bookCallHref">Book a 15-min call →</a>
				<!-- TODO(booking-url) -->
				<a class="hero-cta-secondary" [href]="requestDemoHref">Request Demo</a>
			</div>

			<div class="portal-entry-label">Access Your Portal</div>
			<div class="portal-cards-row">
				<a class="pcard admin" routerLink="/auth/signin/cover">
					<div class="pcard-icon">⚙️</div>
					<div class="pcard-role">Admin</div>
					<div class="pcard-name">Operations Center</div>
					<div class="pcard-desc">Production board, KPI tracking, QC, billing &amp; AI analytics</div>
					<span class="pcard-arrow">Enter portal →</span>
				</a>
				<a class="pcard client" [href]="clientPortalUrl">
					<div class="pcard-icon">📊</div>
					<div class="pcard-role">Client</div>
					<div class="pcard-name">Client Portal</div>
					<div class="pcard-desc">Your leads, campaign progress, billing &amp; QC review requests</div>
					<span class="pcard-arrow">Enter portal →</span>
				</a>
				<a class="pcard caller" [href]="callerPortalUrl">
					<div class="pcard-icon">📞</div>
					<div class="pcard-role">Caller</div>
					<div class="pcard-name">Caller Portal</div>
					<div class="pcard-desc">Assigned campaigns, dial queue, dispositions &amp; daily output</div>
					<span class="pcard-arrow">Enter portal →</span>
				</a>
			</div>
		</div>

		<!-- SISTER STRIP -->
		<div class="sister-strip">
			<div class="sister-inner">
				<span class="sister-label">LMS+ Network</span>
				<div class="sister-divider"></div>
				<div class="sister-brands">
					<div class="sister-brand" title="t3direct.com">
						<div class="sister-brand-dot" style="background:#22C55E;"></div>
						<div>
							<div class="sister-brand-name">T3 Direct</div>
							<div class="sister-brand-url">t3direct.com · Parent Co.</div>
						</div>
					</div>
					<div class="sister-brand" title="app.lmsleads.com">
						<div class="sister-brand-dot" style="background:#1D4ED8;"></div>
						<div>
							<div class="sister-brand-name" style="color:#5B9AEF;">LMS+ Leads</div>
							<div class="sister-brand-url">app.lmsleads.com · Current</div>
						</div>
					</div>
					<div class="sister-brand" title="toplead.io">
						<div class="sister-brand-dot" style="background:#16A34A;"></div>
						<div>
							<div class="sister-brand-name" style="color:#4ADE80;">TopLead</div>
							<div class="sister-brand-url">toplead.io</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</div>
